import { Grid } from "@material-ui/core";
import { useCallback, useEffect } from "react";
import { AutocompleteInput, ReferenceInput, TextInput, useDataProvider } from "react-admin";
import { useForm } from "react-final-form";
import { mytvsuperUrl } from "../../../constant";

export const ChannelSearch = (props) => {
  const formData = props.formData;
  const rest = props.rest;

  // reset the form into initial values
  const form = useForm();
  const dataProvider = useDataProvider();

  const fetchChannel = useCallback(async (param) => {
    const result = await dataProvider.getManyChannelsAutocomplete2({
      ids: [param],
    });

    form.change("network_code_display", result.data[0].network_code);
    form.change("title_tc", result.data[0].name_tc);
    form.change("title_en", result.data[0].name_en);

    // Auto complete "destination_url"
    form.change("destination_url", mytvsuperUrl + "/tc/live/" + result.data[0].channel_no + "/");
  });

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={6}>
        <AutoCompleteChannel clearAlwaysVisible={true} fullWidth formData={formData} {...rest} allowEmpty={true} fetchChannel={fetchChannel} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Content ID" source="network_code_display" disabled fullWidth />
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in TC *" source="title_tc" disabled fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in EN *" source="title_en" disabled fullWidth />
        </Grid>
      </Grid>
    </Grid>
  );
};

const AutoCompleteChannel = (props) => {
  const form = useForm();

  useEffect(() => {});

  return (
    <ReferenceInput
      label="Search Channel Name"
      source="channel_autocomplete"
      reference="channels-autocomplete-2"
      onChange={(val) => {
        props.fetchChannel(val);

        form.change("channel_no", val);
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="channel_text" optionValue="channel_no" fullWidth />
    </ReferenceInput>
  );
};
